import React from 'react';

export const GridPatternBottomRight: React.FC = () => (
  <svg
    className='absolute bottom-0 right-0 pointer-events-none rotate-180'
    xmlns='http://www.w3.org/2000/svg'
    width='179'
    height='99'
    viewBox='0 0 179 99'
    fill='none'
  >
    <rect width='43.2857' height='43.2857' transform='matrix(-1 0 0 1 134.714 -31.7143)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect width='43.2857' height='43.2857' transform='matrix(-1 0 0 1 91.4286 11.5714)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect width='43.2857' height='43.2857' transform='matrix(-1 0 0 1 91.4286 -31.7143)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect x='-38.4286' y='11.5714' width='43.2857' height='43.2857' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect x='-38.4286' y='-31.7143' width='43.2857' height='43.2857' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect width='43.2857' height='43.2857' transform='matrix(-1 0 0 1 48.1428 54.8572)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect width='43.2857' height='43.2857' transform='matrix(-1 0 0 1 48.1428 11.5714)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
    <rect width='43.2857' height='43.2857' transform='matrix(-1 0 0 1 48.1428 -31.7143)' stroke='white' strokeOpacity='0.12' strokeWidth='0.309184' />
  </svg>
);
